import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import ReimbursementClaimPaymentForm, {
    ReimbursementClaimPaymentFormProps
} from "../../../pages/reimbursements/components/claims/ReimbursementClaimPaymentForm";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, ReimbursementClaimPaymentFormProps {
}

type Props = OwnProps;

// @ts-ignore
const ReimbursementClaimPaymentModal = NiceModal.create<Props>(({reimbursementClaim, onClose, header, ...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <ReimbursementClaimPaymentForm reimbursementClaim={reimbursementClaim} {...rest}/>
        </SlideOver>
    )
})

export default ReimbursementClaimPaymentModal;
